import { cn } from "@/lib/utils";
import type { TimelineEvento } from "@/types/timeline";
import { eventTypeIcon, laneConfig } from "./timelineEventUtils";

const DOT_SIZE = {
  xs: { circle: "h-4 w-4", icon: "h-2.5 w-2.5" },
  sm: { circle: "h-5 w-5", icon: "h-3 w-3" },
  md: { circle: "h-6 w-6", icon: "h-3.5 w-3.5" },
} as const;

/**
 * Marco de evento: ícone por event_type + cor por lane (cor nunca sozinha,
 * ícone sempre presente). Evento inferido (reconstruído do histórico) rende
 * com contorno tracejado e opacidade reduzida.
 */
export function TimelineEventDot({
  evento,
  size = "md",
  className,
}: {
  evento: TimelineEvento;
  size?: keyof typeof DOT_SIZE;
  className?: string;
}) {
  const EventIcon = eventTypeIcon(evento.event_type);
  const lane = laneConfig(evento.lane);
  const sizing = DOT_SIZE[size];
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center justify-center rounded-full border bg-clip-padding",
        lane.dotClass,
        evento.inferred && "border-dashed opacity-70",
        sizing.circle,
        className,
      )}
      aria-hidden
    >
      <EventIcon className={sizing.icon} />
    </span>
  );
}

export default TimelineEventDot;
